import PropTypes from 'prop-types';

//This will match the output of the
//collection selector present in this duck.
export const COLLECTION_PROP_TYPE = PropTypes.arrayOf(
    PropTypes.shape({
        eventCount: PropTypes.number,
        href: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
    }),
);
